export const DiamondWhite = ({
  color,
  size,
  className,
}: {
  className?: string;
  color?: string;
  size?: number;
}) => {
  return (
    <svg
      className={className}
      width={size || "16"}
      height={size || "16"}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.71875 2.61251V4.06876L4.22813 3.58751C4.50625 3.32501 5.19375 2.67501 5.75938 2.14376C6.32188 1.61563 6.78125 1.17813 6.78125 1.16876C6.78125 1.16251 6.09375 1.15626 5.25 1.15626H3.71875V2.61251Z"
        fill={color || "white"}
      />
      <path
        d="M9.21875 1.16875C9.21875 1.1875 12.2438 4.03125 12.2656 4.03125C12.275 4.03125 12.2812 3.38437 12.2812 2.59375V1.15625H10.75C9.90938 1.15625 9.21875 1.1625 9.21875 1.16875Z"
        fill={color || "white"}
      />
      <path
        d="M6.2125 3.00625L4.4375 4.67188L6.21875 4.68125C7.2 4.68437 8.80312 4.68437 9.78125 4.68125L11.5625 4.67188L9.8 3.01563C8.83125 2.10625 8.025 1.35625 8.00938 1.35313C7.99688 1.34688 7.1875 2.09375 6.2125 3.00625Z"
        fill={color || "white"}
      />
      <path
        d="M1.45015 3.25625C0.731397 4.0125 0.134522 4.64687 0.131397 4.6625C0.125147 4.675 0.718897 4.6875 1.45015 4.6875H2.7814V3.28125C2.7814 2.50625 2.77827 1.875 2.77202 1.875C2.76577 1.875 2.17202 2.49688 1.45015 3.25625Z"
        fill={color || "white"}
      />
      <path
        d="M13.2188 3.275V4.6875H14.5469C15.2781 4.6875 15.875 4.67812 15.875 4.66875C15.875 4.65312 13.8156 2.47187 13.3875 2.03125L13.2188 1.85938V3.275Z"
        fill={color || "white"}
      />
      <path
        d="M0.0376421 5.65001C0.0563921 5.70001 6.16577 13.0656 6.17514 13.0531C6.18139 13.0469 5.45952 11.375 4.56889 9.34063L2.95327 5.64063L1.48764 5.63126C0.684517 5.62813 0.0313921 5.63751 0.0376421 5.65001Z"
        fill={color || "white"}
      />
      <path
        d="M4.04062 5.7875C4.08125 5.87813 4.98438 7.94688 6.05 10.3812C7.1125 12.8188 7.99062 14.8125 8 14.8125C8.00938 14.8125 8.8875 12.8188 9.95 10.3812C11.0156 7.94688 11.9188 5.87813 11.9594 5.7875L12.0312 5.625H8H3.96875L4.04062 5.7875Z"
        fill={color || "white"}
      />
      <path
        d="M12.9846 5.78751C12.6783 6.46251 9.81584 13.0438 9.82522 13.0531C9.83459 13.0656 15.944 5.70001 15.9627 5.65001C15.969 5.63751 15.319 5.62501 14.5158 5.62501H13.0596L12.9846 5.78751Z"
        fill={color || "white"}
      />
    </svg>
  );
};

export const Star = ({color,size,className}:{color: "green" | "yellow" | "salmon",size?:number,className?:string}) => {
  return (
    <svg className={className} width={size || "38"} height={size || "36"} viewBox="0 0 38 36" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M19.4723 3.83584L19 2.47714L18.5277 3.83584L14.8801 14.3295L3.77291 14.5558L2.33477 14.5851L3.48102 15.4542L12.3339 22.1659L9.11686 32.7995L8.70032 34.1763L9.88103 33.3547L19 27.0091L28.119 33.3547L29.2997 34.1763L28.8831 32.7995L25.6661 22.1659L34.519 15.4542L35.6652 14.5851L34.2271 14.5558L23.1199 14.3295L19.4723 3.83584Z"
        fill={color === "green" ? "#10C700" : color === "yellow" ? "#FFF500" : "#FF7875"}
        stroke="black"
      />
    </svg>
  );
};
